const state = () => ({
    _show: false,
    _isInboxesFlow: false,
});

const getters = {
    trialLimitReachedShow: (state) => state._show,
    trialLimitReachedShowInboxesFlow: (state) => state._isInboxesFlow,
};

const actions = {
    showTrialLimitReachedModal({ status, inboxesFlowStatus = false }) {
        this._setTrialLimitReachedModal({ status, inboxesFlowStatus });
    },

    _setTrialLimitReachedModal({ status, inboxesFlowStatus }) {
        this._show = status;
        this._isInboxesFlow = inboxesFlowStatus;
    },
};

export default {
    state,
    getters,
    actions,
};
